import UserNew from './UserNew'

export default UserNew;